import PatientSignatureImage from './PatientSignatureImage';

const CoManaged = ({
    pageRefs,
    currentPage,
    logo,
    pageTitles,
    SurgeryFormData,
    surgeonOptionsMap,
    docSignature,
    setSignatures,
    setSurgeryFormData,
    handleInputChange,
    invalidFields,
    isNext,
    isEditing,
    signatures,
    canvasRefs,
    updateSignatureData,
    clearSignature,
    toggleEditMode,
    getCentralAmericaDate,
    getCentralAmericaTime,
    Logo,
    Head,
    Paragraph,
    RadioGroup,
    TextInput,
    SignatureField,
    SegLogoBanner,
    Initials,
    surgeryUpload,
    FormInput,
    MultiSelectorWithoutEyes,
    handleCheckboxChange,
    formattedDate
}) => {

    return (
        <div ref={pageRefs.current[currentPage]} className="max-w-5xl w-full bg-white">
            <div className="px-1 mx-8 py-2">
                <SegLogoBanner src={logo} />
                <Head title="Co-Management Agreement" />

                <div className="space-y-2">
                    <Paragraph>
                        Date: <span className="underline font-bold">{formattedDate}</span>
                    </Paragraph>
                    <Paragraph>
                        Patient Name: <span className="underline font-bold">{SurgeryFormData.first_name} {SurgeryFormData.last_name}</span>  DOB: <span className="underline font-bold">{SurgeryFormData.dob}</span>
                    </Paragraph>

                    <Paragraph>
                        Surgeon: <span className="underline font-bold">{SurgeryFormData.surgeon} </span>
                    </Paragraph>
                </div>

                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {[
                        {
                            id: "referring_doctor",
                            label: "Referring Doctor",
                            required: true,
                        },
                        {
                            id: "referring_doctor_phone",
                            label: "Phone Number",
                            required: true,
                        }
                    ].map(({ id, label, required }) => (
                        <FormInput
                            key={id}
                            id={id}
                            label={label}
                            type="text"
                            disabled={isNext}
                            value={SurgeryFormData[id]}
                            onChange={handleInputChange}
                            invalid={invalidFields.includes(id) && !SurgeryFormData[id]}
                            required={required}
                        />
                    ))}
                </div>

                <div className="my-6">
                    <span className="underline font-bold">Patient Confirmation:</span>
                    <div className="space-y-3 mt-3">
                        <Paragraph>
                            Dr. <span className="font-bold underline">{SurgeryFormData.surgeon}</span> (Surgeon) will be performing my cataract surgery.
                        </Paragraph>
                        <Paragraph>
                            It is my preference to have my own ophthalmologist/optometrist listed above (Referring Provider) provide
                            my postoperative follow-up care for convenience and continuity of care.
                        </Paragraph>
                        <Paragraph>
                            I understand that my ophthalmologist/optometrist will contact Dr.<span className="font-bold underline">{SurgeryFormData.surgeon}</span>
                            (Surgeon) immediately if I experience any complications related to my eye surgery. I also understand that I
                            may contact my surgeon directly at any time following surgery.
                        </Paragraph>
                    </div>
                </div>

                <div className="my-6">
                    <Paragraph>
                        Patient Name: <span className="underline font-bold">{SurgeryFormData.first_name} {SurgeryFormData.last_name}</span>
                    </Paragraph>
                </div>

                <div className="my-4">
                    <PatientSignatureImage
                        signature={SurgeryFormData['patient_signature']}
                        label="Patient/Guardian Signature"
                        signedDate={SurgeryFormData.patientSignedDate}
                    />
                </div>
            </div>
        </div>
    );
};

export default CoManaged;